export default {
  'Extract audio': 'Sesi çıkar',
  'Mute': 'Sessiz',
  'Split video and audio': 'Video ve sesi böl',
}